export default "__VITE_ASSET__B8TxTz7g__"